(function () {
  if (window.__pcardTickerReady) return;
  window.__pcardTickerReady = true;

  function initTicker(wrap) {
    if (wrap.dataset.tickerInit) return;
    wrap.dataset.tickerInit = '1';

    var items = wrap.querySelectorAll('.pcard-scrolling-item');
    if (items.length <= 1) return;

    var current = 0;
    var interval = parseInt(wrap.dataset.interval, 10) || 3000;

    setInterval(function () {
      var prev = items[current];
      current = (current + 1) % items.length;
      var next = items[current];

      prev.classList.add('is-exiting');
      prev.classList.remove('is-active');

      setTimeout(function () {
        prev.classList.remove('is-exiting');
      }, 400);

      next.classList.add('is-active');
    }, interval);
  }

  function initAll() {
    document.querySelectorAll('.pcard-scrolling-wrap:not([data-ticker-init])').forEach(initTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
